import { useParams } from "react-router-dom";
import EditClientSubAccount from "./EditClientSubAccount";
import { useGetClientSubAccountByIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForClientSubAccount";
import { Fragment } from "react";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import { useGetAccountAdminListQuery, useGetLanguageListQuery, useGetCurrencyListQuery, useGetClientTypeClassificationQuery } from "../../../../../reactQueries/commonRQHooks";

const EditClientSubAccountHome = () => {

    let { id } = useParams()

    const { isSuccess, isFetching, data: clientSubAccountById, isError } = useGetClientSubAccountByIdQuery({ clientSubAccountId: id })

    const { data: LangList } = useGetLanguageListQuery();

    const { data: CurrencyList } = useGetCurrencyListQuery();

    const { data: ClientTypeList } = useGetClientTypeClassificationQuery();

    const { data: accountAdminListFromAPI } = useGetAccountAdminListQuery();

    return (
        <Fragment>
            {
                (!!isFetching) && "Wait Loading...."
            }
            {
                (!!isSuccess) && (<EditClientSubAccount
                    clientSubAccountDataById={clientSubAccountById}
                    LangList={LangList || []}
                    CurrencyList={CurrencyList || []}
                    ClientTypeList={ClientTypeList || []}
                    accountAdminListFromAPI={accountAdminListFromAPI || []}
                />)
            }
            <MpgErrorDialog
                open={!!isError}
            />
        </Fragment>
    )


}
export default EditClientSubAccountHome